// 入住订单相关的接口
import fetch from '../tjFetch.js'
import abLS from '@/business/abLocalStorage'
import { PWD_BUSINESS_TYPE } from '@/business/config'
import { IApi } from './types'
import request from '@/apiFetch/request'

const apiConfig = {
  getUserOrderList: `/api/pms/order/list.api`,
  getOrderNumber: `/api/pms/order/orderNumber.api`,
  getUserOrderDetail: `/api/pms/bookOrder/detail.api`,
  addUserOrder: `/api/pms/bookOrder/add.api`,
  updateUserOrder: `/api/pms/bookOrder/edit.api`,
  cancelUserOrder: `/api/pms/bookOrder/cancel.api`,
  userOrderCheckIn: `/api/pms/bookOrder/checkin.api`,
  userOrderCheckOut: `/api/pms/bookOrder/checkout.api`,
  distributionRoom: `/api/pms/bookOrder/roomAssign.api`,
  distributionRoomOrderList: `/api/pms/bookOrder/roomAssign/list.api`,
  uploadFile: `/api/pms/common/uploadFile.api`,
  needUploadImage: `/api/pms/auth/needUploadImage.api`,
  artificial: `/api/pms/auth/artificial.api`,
  getMsgInfo: `/api/pms/auth/showMsg.api`,
  sendMsg: `/api/pms/auth/sendMsg.api`,
  getPendingList: `/api/pms/cameraAuthOrder/pendingList.api`,
  openerConfirm: `/api/pms/cameraAuthOrder/confirm.api`,
  prevAuth: '/api/pms/auth/realNameAuth.api',
  registerList: '/api/pms/register/list.api',
  deleteRegister: '/api/pms/register/delete.api',
  isNoLock: '/api/pms/bookOrder/getHotelType.api', // 是否是无锁门店
  // 订单详情设置密码-列表
  passwordList: '/api/pms/bookOrder/pwdList.api',
  // 获取离线密码
  createOfflinePassword: '/api/pms/pwd/createOfflinePassword.api',
  // 更新密码有效期
  numPwdUpdate: '/api/pms/pwd/numPwdUpdate.api',
  // 重新下发密码
  resendPwd: '/api/pms/pwd/getManualPassword.api',
  // 获取智能短信模板
  msgTmpList: '/api/pms/auth/list.api',
  // 获取订单日志
  getOrderLog: '/api/pms/bookOrder/orderLog.api'
}
const getData = (fromData: any, isFormData = false) => {
  const config: any = {
    headers: {
      accessToken: abLS.getAccessToken() || ''
    }
  }
  if (isFormData) {
    config.timeout = 20000
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
  }
  const data = {
    data: fromData || {},
    ...config,
    withCredentials: true
  }
  return data
}

const api: IApi = {
  /** 获取订单列表 */
  getUserOrderList(fromData) {
    return fetch.post(apiConfig.getUserOrderList, getData(fromData))
  },
  /** 获取订单数量 */
  getOrderNumber(fromData) {
    return fetch.post(apiConfig.getOrderNumber, getData(fromData))
  },
  /** 待分房订单列表 */
  distributionRoomOrderList(fromData) {
    return fetch.post(apiConfig.distributionRoomOrderList, getData(fromData))
  },
  /** 获取订单详情 */
  getUserOrderDetail(fromData) {
    return fetch.post(apiConfig.getUserOrderDetail, getData(fromData))
  },
  /** 新增旅客单，增加密码设置路径 */
  addUserOrder(fromData) {
    return fetch.post(
      apiConfig.addUserOrder,
      getData({
        ...fromData,
        businessType: PWD_BUSINESS_TYPE.OP_ORDER
      })
    )
  },
  /** 修改旅客单 */
  updateUserOrder(fromData) {
    return fetch.post(
      apiConfig.updateUserOrder,
      getData({
        ...fromData,
        businessType: PWD_BUSINESS_TYPE.OP_ORDER
      })
    )
  },
  /** 取消旅客单 */
  cancelUserOrder(fromData) {
    return fetch.post(
      apiConfig.cancelUserOrder,
      getData({
        ...fromData,
        businessType: PWD_BUSINESS_TYPE.OP_ORDER
      })
    )
  },
  /** 办理入住 */
  userOrderCheckIn(fromData) {
    return fetch.post(apiConfig.userOrderCheckIn, getData(fromData))
  },
  /** 办理退房 */
  userOrderCheckOut(fromData) {
    return fetch.post(apiConfig.userOrderCheckOut, getData(fromData))
  },
  /** 分房 */
  distributionRoom(fromData) {
    return fetch.post(apiConfig.distributionRoom, getData(fromData))
  },
  /** 上传照片 */
  uploadFile(fromData) {
    return fetch.post(apiConfig.uploadFile, getData(fromData, true))
  },
  /** 人工认证 */
  artificial(fromData) {
    return fetch.post(
      apiConfig.artificial,
      getData({
        ...fromData,
        businessType: PWD_BUSINESS_TYPE.MANUAL_AUTH
      })
    )
  },
  /** 判断入住人是否需要上传证件照片 */
  needUploadImage(fromData) {
    return fetch.post(apiConfig.needUploadImage, getData(fromData))
  },
  /** 待确认开门人员身份列表 */
  getPendingList(fromData) {
    return fetch.post(apiConfig.getPendingList, getData(fromData))
  },
  /** 确认开门人员身份 */
  openerConfirm(fromData) {
    return fetch.post(apiConfig.openerConfirm, getData(fromData))
  },
  /** 校验身份信息 */
  prevAuth(fromData) {
    return fetch.post(apiConfig.prevAuth, getData(fromData))
  },
  /** 无锁门店登记入住人列表 */
  registerList(fromData) {
    return fetch.post(apiConfig.registerList, getData(fromData))
  },
  /** 删除指定的入住人 */
  deleteRegister(fromData) {
    return fetch.post(apiConfig.deleteRegister, getData(fromData))
  },
  /** 门锁密码列表 */
  passwordList(fromData) {
    return fetch.post(apiConfig.passwordList, getData(fromData))
  },
  /** 获取离线密码 */
  createOfflinePassword(fromData) {
    return fetch.post(apiConfig.createOfflinePassword, getData(fromData))
  },
  /** 更新密码有效期 */
  numPwdUpdate(fromData) {
    return fetch.post(apiConfig.numPwdUpdate, getData(fromData))
  },
  /** 重新下发密码 */
  resendPwd(fromData) {
    return fetch.post(apiConfig.resendPwd, getData(fromData))
  },
  /** 获取短信模板内容 */
  getMsgInfo(fromData) {
    return fetch.post(apiConfig.getMsgInfo, getData(fromData))
  },
  /** 发送短信 */
  sendMsg(fromData) {
    return fetch.post(apiConfig.sendMsg, getData(fromData))
  },
  /** 获取智能短信模板列表 */
  msgTmpList(fromData) {
    return fetch.post(apiConfig.msgTmpList, getData(fromData))
  },
  /** 获取订单日志 */
  getOrderLog(params) {
    return request.get(apiConfig.getOrderLog, { params })
  }
}

export default api
